angular.module('vastdesk').
  component('campaignDemandPartnerFields',  {
    bindings: {
      demandPartnerId: '@',
      demandPartnerName: '@',
      accountManagers: '@',
      newRecord: '<',
      staticDemandPartner: '<',
      staticDemandPartnerReason: '@',
      formErrorClass: '@',
      demandPartnerOptions: '<',
      tomSelectAjax: '<',
    },
    template: require("../templates/campaignDemandPartnerFields.html"),
    controllerAs: '$campaignDemandPartnerFieldsCtrl',
    controller: ['$interval','$rootScope', function($interval, $rootScope) {

      var self = this;

      var demandPartnerDomIds = "#campaign_demand_partner_id";

      var toggleDemandPartnerContentVisibility = function() {
        $('.demand-partner-hidden').toggleClass('hidden', !!self.demandPartnerId);
        $('.demand-partner-shown').toggleClass('hidden', !self.demandPartnerId);
      };

      this.changeDemandPartner = function () {
        var selectedDemandPartner = $(demandPartnerDomIds).val();
        self.demandPartnerId = selectedDemandPartner;
        toggleDemandPartnerContentVisibility();
        fetchDemandPartnerData(selectedDemandPartner);

        $rootScope.$broadcast("demandPartnerIdChange", {
          demandPartnerId: self.demandPartnerId,
        });

        if (self.newRecord) {
          $rootScope.$broadcast("clearCampaignDemandTags");
        }
      };

      var fetchDemandPartnerData = function (demandPartnerId) {
        // Fetch campaign data from the API
        fetch(
          "/api/v1/demand_partners/" +
            demandPartnerId +
            "?include=account_managers.user"
        )
          .then((response) => response.json())
          .then((dp) => {
            self.accountManagers =
              dp.account_managers &&
              dp.account_managers
                .map(
                  (accountManager) =>
                    accountManager.user.name || accountManager.user.email
                )
                .join(", ");

            $rootScope.$broadcast("sequentialLiabilityChange", {
              // sequential_liability_approved is only supplied by the demand partner serializer
              // if enabled on the account, so its implicitly approved if not present,
              // otherwise check if it's explicitly true
              approved:
                !Object.prototype.hasOwnProperty.call(
                  dp,
                  "sequential_liability_approved"
                ) || dp.sequential_liability_approved === true,
            });
          })
          .catch((error) => {
            console.error("Error fetching demand partner data:", error);
          });
      };

      this.$onInit = function () {
        toggleDemandPartnerContentVisibility();

        // connect tom-select change event
        var intervalId = $interval(function () {
          var demandPartnerSelect = $(demandPartnerDomIds);
          if (demandPartnerSelect[0] && demandPartnerSelect[0].tomselect) {
            $interval.cancel(intervalId);
            demandPartnerSelect[0].tomselect.on("change", function () {
              self.changeDemandPartner();
            });
          }
        }, 1);
      };
    },
  ],
});
